<template>
  <v-dialog v-model="dialog" fullscreen content-class="fullscreen-dialog">
    <Header headTitle="개인정보 처리방침" isShowBackBtn @clickBack="cancel" />
    <div class="policy-page"  >
      <div style="display: flex;" class="agree-content">
        <h6 style="margin-top: auto; margin-bottom: auto; margin-right: 6px;">
          <strong>시행일자 별 개인정보 처리방침:</strong>
        </h6>
        <v-select
          v-if="effectiveDateList.length > 0"
          :items="effectiveDateList"
          item-text="effectiveDate"
          item-value="policyId"
          placeholder="시행일자를 선택해 주세요"
          append-icon="mdi-chevron-down"
          v-model="selectedPolicyId"
        />
      </div>

      <div v-if="selectedPolicy" class="agree-content">
        <div v-html="selectedPolicy.agreeTerms"></div>
        <h6>[개인정보의 제3자 제공에 대한 동의]</h6>
        <div v-html="selectedPolicy.agreePolicy"></div>
        <h6>[의・약학적 정보 전달 및 제품홍보 등 마케팅 안내 관련 동의]</h6>
        <div v-html="selectedPolicy.agreeMarketing"></div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import DetailHeader from "@/_zplabZPT/commonComp/DetailHeader.vue";
import Marketing from "@/_zplabZPT/commonComp/policy/Marketing.vue";
import Policy from "@/_zplabZPT/commonComp/policy/Policy.vue";
import Terms from "@/_zplabZPT/commonComp/policy/Terms.vue";
import Header from "@/_zplabZPT/commonComp/Header.vue";
export default {
  components: {
    DetailHeader,
    Terms,
    Policy,
    Marketing,
    Header
  },
  props: {},
  data() {
    return {
      effectiveDateList: [],
      selectedPolicyId: null,  // policyId만 관리
      dialog: false,
      tab: null,
    };
  },
  methods: {
    open(_tab) {
      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
      this.$emit("clickCancel");
    },
    ...mapActions(["getPolicy"]),
  },
computed: {
  selectedPolicy() {
    return this.effectiveDateList.find(
      (p) => p.policyId === this.selectedPolicyId
    );
  }
},
  mounted() {
    this.getPolicy().then((res) => {
      if (!res) return;
      this.policyData = res;

      // effectiveDateList 세팅
      this.effectiveDateList = res.data.map(policy => ({
        policyId: policy.policy_id,
        effectiveDate: this.$moment(policy.effectiveDate).format('YYYY년 MM월 DD일'),
        agreePolicy: policy.agreePolicy,
        agreeTerms: policy.agreeTerms,
        agreeMarketing: policy.agreeMarketing,

      }));

      // selectedPolicyId 초기값 세팅
      if (this.effectiveDateList.length > 0) {
        // nextTick으로 렌더링 후에 v-model 값 세팅
        this.$nextTick(() => {
          this.selectedPolicyId = this.effectiveDateList[0].policyId; // 초기값
        });
      }

    });
  }
};
</script>

<style lang="scss">
.v-dialog.fullscreen-dialog {
  overflow-y: auto;
  .policy-page{
    background: #ffffff !important;
    padding: 10px;
    margin-top: 100px;
  }
  .agree-content  {
    width: 90vw;
    margin: 0 auto;
    font-size: 10px;
    // overflow: auto;
    // height: calc(100vh - 77px);

    table {
      width: 100%;
      border-top: 1px solid var(--v-info-lighten4);
      border-collapse: collapse;
      margin: 20px 0 40px;
      font-size: 11px;
    }

    th {
      width: 100px;
      background:var(--v-info-lighten5);
      font-weight: 500;
      text-align: left;
      vertical-align: top;
    }

    th,
    td {
      border: 1px solid var(--v-info-lighten4);
      padding: 0.5rem;
    }
  }
  .v-tabs-items {
    margin-top: 1rem;
    font-size: 14px;
  }
}
</style>
